<div class="main-container" style="max-width: 100%;">
  <div class="page-header">
    <div  fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <button mat-stroked-button matTooltip="Re-login to PBX server" (click)="loginUserToPbx()">
        <mat-icon>refresh</mat-icon>
        Re-login
      </button>
      <a mat-stroked-button
         href="https://{{this.currentUser.domain}}/usr_portal.htm" target="_blank"
         matTooltip="Open PBX Server in new page">
        <mat-icon fontSet="fa" fontIcon="fa-external-link-alt" class="icon-14"></mat-icon>
        Manual Login
      </a>
    </div>
  </div>
  <div class="card last">
    <div class="card-body grid" [style.height]="gridHeight">
      <div class="progress-wrapper" *ngIf="isLoading" [ngClass]="{'is-loading' : isLoading}">
        <span class="k-i-loading k-icon"></span>
      </div>
      <div class="error-wrapper" *ngIf="hasError" [ngClass]="{'has-error' : hasError}">
            <span class="error-description">
              {{errorMessage}}
            </span>
      </div>
      <iframe *ngIf="showIframe" [src]="pbxUrl" width="100%" height="100%" frameborder="0"
              allow="camera; microphone; speaker"></iframe>
    </div>
  </div>
</div>
